import React, { useEffect } from "react";
import TagManager from "react-gtm-module";

const GTMInitializer = ({ children }) => {
  useEffect(() => {
    TagManager.initialize({ gtmId: "GTM-K2L63366" }); // Replace 'GTM-XXXXXXX' with your GTM ID
  }, []);
  return <>{children}</>;
};

export default GTMInitializer;
